import type { JSX } from "react";
import type { PanelToolbarAction } from "./panel";
import { styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ToolButton } from "../../atoms/tool-button";


const PanelToolbarRoot = styled("div")`
	display: flex;
	flex-direction: row;
	&, button {
		height: 100%;
	}
`;

export type PanelToolbarProps = {
	toolbar?: readonly PanelToolbarAction[];
	disabled?: boolean;
};
export const PanelToolbar = ({ toolbar, disabled }: PanelToolbarProps): JSX.Element | null => {
	const { t } = useTranslation();

	if(!toolbar) {
		return null;
	}

	return (
		<PanelToolbarRoot>
			{ toolbar.filter(action => action.condition !== false).map((action, index) => {
				const label = action.label ?? t(action.labelKey) as string;
				return (
					<ToolButton
						label={ label }
						icon={ action.icon }
						color={ action.color }
						disabled={ disabled || action.disabled }
						onClick={ action.onClick ?? undefined }
						fullLabel={ action.fullLabel }
						key={ index }
					/>
				);
			}) }
		</PanelToolbarRoot>
	);
};
